<template>
    <div id="mail-preview" :style="{backgroundColor: `${properties.background_color} !important`}">
        <div class="meta">
            <div>
                <strong>{{ $t('design_mail_branding.preview.from') }}</strong>
                Gifty
                <i>&lt;info@gifty.nl&gt;</i>
            </div>

            <div>
                <strong>{{ $t('design_mail_branding.preview.subject') }}</strong>
                {{ $t('design_mail_branding.preview.subject_line', { name: $store.getters['user/activeCompany'].name, orderNumber: '2025324503' }) }}
            </div>

            <div class="attachments">
                <strong>{{ $t('design_mail_branding.preview.attachment') }}</strong>
                <div class="attachment">
                    <i class="icon">attachment</i>
                    cadeaubon-JW96-S75S-9FV8-L9S4.pdf
                </div>
            </div>
        </div>

        <div class="email-bg">
            <div class="email-body"
                 :style="{
                    fontFamily: `${cssSafeFontFamily(properties.font_family)} !important`,
                    color: `${properties.content_foreground_color} !important`,
                    backgroundColor: `${properties.content_background_color} !important`,
                }">
                <div class="email-body-header">
                    <slot name="header"></slot>
                </div>

                <div class="email-body-content" :style="{ color: `${properties.content_foreground_color} !important` }">
                    <div class="header">{{ $t('design_mail_branding.preview.order_confirmation_header') }}</div>
                    <span class="body">
                        <i18n path="design_mail_branding.preview.thank_you_message" tag="span">
                            <template #orderNumber>
                                <strong :style="{ color: `${properties.content_foreground_color} !important` }">2025324503</strong>
                            </template>
                            <template #companyName>
                                <strong :style="{ color: `${properties.content_foreground_color} !important` }">{{ $store.getters['user/activeCompany'].name }}</strong>
                            </template>
                        </i18n>
                        <br/><br/>
                        {{ $t('design_mail_branding.preview.enjoy_gift') }}
                        <br/><br/>
                        {{ $t('design_mail_branding.preview.kind_regards') }}<br/>
                        {{ $store.getters['user/activeCompany'].name }}
                    </span>

                    <br/><br/>
                    <div class="download-button" :style="{
                        backgroundColor: `${properties.button_background_color} !important`,
                        color: `${properties.button_foreground_color} !important`,
                        padding: `${properties.button_vertical_padding}px ${properties.button_horizontal_padding}px !important`,
                        borderRadius: `${properties.button_border_radius}px !important`,
                    }">{{ $t('design_mail_branding.preview.download_order') }}</div>
                    <br/><br/>

                    <table :style="{
                                backgroundColor: `${properties.table_background_color} !important`,
                                color: `${properties.table_foreground_color} !important`,
                                '--border-color': properties.table_border_color
                            }">
                        <thead style="font-weight: bold">
                        <tr>
                            <th :style="{ color: `${properties.table_foreground_color} !important` }">{{ $t('design_mail_branding.preview.product') }}</th>
                            <th :style="{ color: `${properties.table_foreground_color} !important` }" style="text-align: right;">{{ $t('design_mail_branding.preview.quantity') }}</th>
                            <th :style="{ color: `${properties.table_foreground_color} !important` }" style="text-align: right;">{{ $t('design_mail_branding.preview.price') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{ $t('design_mail_branding.preview.gift_voucher', { companyName: $store.getters['user/activeCompany'].name }) }}</td>
                            <td style="text-align: right;">1</td>
                            <td style="text-align: right;">&euro; 50,00</td>
                        </tr>
                        <tr>
                            <td>{{ $t('design_mail_branding.preview.print_shipping_costs') }}</td>
                            <td>&nbsp;</td>
                            <td style="text-align: right;">&euro; 0,00</td>
                        </tr>
                        <tr>
                            <td style="font-weight: bold;">{{ $t('design_mail_branding.preview.total') }}</td>
                            <td>&nbsp;</td>
                            <td style="text-align: right; font-weight: bold;">&euro; 0,00</td>
                        </tr>
                        </tbody>
                    </table>

                    <br/>
                    <strong :style="{ color: `${properties.content_foreground_color} !important` }">{{ $t('design_mail_branding.preview.order_ease_question') }}</strong>
                    <br/>

                    <img src="../../../../../images/email/nps/emoti-1.png" alt="Review icon" class="nps-icon">
                    <img src="../../../../../images/email/nps/emoti-2.png" alt="Review icon" class="nps-icon">
                    <img src="../../../../../images/email/nps/emoti-3.png" alt="Review icon" class="nps-icon">
                    <img src="../../../../../images/email/nps/emoti-4.png" alt="Review icon" class="nps-icon">
                    <img src="../../../../../images/email/nps/emoti-5.png" alt="Review icon" class="nps-icon">
                </div>

                <div class="email-support-footer">
                    <slot name="footer">
                        <i18n path="design_mail_branding.preview.support_message" tag="span">
                            <template #email>
                                <u :style="{ color: properties.content_hyperlink_color }">info@gifty.nl</u>
                            </template>
                            <template #orderNumber>2025324503</template>
                        </i18n>
                    </slot>
                </div>

                <div class="footer-logo" :style="{ '--divider-color': properties.divider_color }">
                    <img v-if="backgroundRequiresLightLogo" src="../../../../../images/email/gifty-logo-light.png" alt="Gifty">
                    <img v-else src="../../../../../images/email/gifty-logo.png" alt="Gifty">
                </div>
            </div>

            <!-- We apply the foreground color based on the contrast, except for when it's #eceff0 (default background), -->
            <!-- since we want to apply a slightly different color in that case (#a7a7a7) -->
            <div class="email-footer" :class="footerRequiresLightText ? 'light-text' : 'dark-text'"
                 :style="{ color: properties.background_color.toLowerCase() === '#eceff0' ? '#a7a7a7' : getContrastingTextColor }"
                 >
                {{ $t('design_mail_branding.preview.company_footer', { email: 'info@gifty.nl', terms: $t('design_mail_branding.preview.terms_conditions'), privacy: $t('design_mail_branding.preview.privacy_policy') }) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailViewItem',
    props: {
        properties: {
            type: Object
        }
    },

    computed: {
        getContrastingTextColor() {
            // Use the footer background color from properties
            const backgroundColor = this.properties.background_color;

            if (!backgroundColor) {
                return '#000000'; // Default to black if no background color
            }

            // Calculate contrast ratio between two colors
            const calculateContrastRatio = (color1, color2) => {
                const getLuminance = (hex) => {
                    // Normalize hex (#fff -> #ffffff)
                    let color = hex.replace("#", "");
                    if (color.length === 3) {
                        color = color.split("").map(c => c + c).join("");
                    }

                    // Parse hex as RGB
                    const r = parseInt(color.substring(0, 2), 16);
                    const g = parseInt(color.substring(2, 4), 16);
                    const b = parseInt(color.substring(4, 6), 16);

                    // Convert to relative luminance
                    const rsRGB = r / 255;
                    const gsRGB = g / 255;
                    const bsRGB = b / 255;

                    const rLum = rsRGB <= 0.03928 ? rsRGB / 12.92 : Math.pow((rsRGB + 0.055) / 1.055, 2.4);
                    const gLum = gsRGB <= 0.03928 ? gsRGB / 12.92 : Math.pow((gsRGB + 0.055) / 1.055, 2.4);
                    const bLum = bsRGB <= 0.03928 ? bsRGB / 12.92 : Math.pow((bsRGB + 0.055) / 1.055, 2.4);

                    return 0.2126 * rLum + 0.7152 * gLum + 0.0722 * bLum;
                };

                const lum1 = getLuminance(color1);
                const lum2 = getLuminance(color2);
                const brightest = Math.max(lum1, lum2);
                const darkest = Math.min(lum1, lum2);

                return (brightest + 0.05) / (darkest + 0.05);
            };

            // Determine if white or black has better contrast
            const contrastWithBlack = calculateContrastRatio(backgroundColor, '#000000');
            const contrastWithWhite = calculateContrastRatio(backgroundColor, '#ffffff');

            return contrastWithBlack > contrastWithWhite ? '#000000' : '#ffffff';
        },

        footerRequiresLightText() {
            return this.getContrastingTextColor === '#ffffff';
        },

        // Refactored existing computed property to use shared logic
        backgroundRequiresLightLogo() {
            const hex = this.properties.content_background_color;

            if (!hex) {
                return false;
            }

            // Reuse the luminance calculation logic
            const getLuminance = (hexColor) => {
                // Normalize hex (#fff -> #ffffff)
                let color = hexColor.replace("#", "");
                if (color.length === 3) {
                    color = color.split("").map(c => c + c).join("");
                }

                // Parse hex as RGB
                const r = parseInt(color.substring(0, 2), 16);
                const g = parseInt(color.substring(2, 4), 16);
                const b = parseInt(color.substring(4, 6), 16);

                // Simplified brightness calculation (your existing formula)
                return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            };

            const brightness = getLuminance(hex);
            return brightness < 0.5;
        }
    },

    methods: {
        cssSafeFontFamily(value) {
            const fontFamilyCSSMapping = {
                'arial': 'Arial, sans-serif',
                'helvetica': 'Helvetica, Arial, sans-serif',
                'verdana': 'Verdana, Geneva, sans-serif',
                'tahoma': 'Tahoma, Geneva, sans-serif',
                'trebuchet_ms': '"Trebuchet MS", Helvetica, sans-serif',
                'times_new_roman': '"Times New Roman", Times, serif',
                'georgia': 'Georgia, "Times New Roman", serif',
                'garamond': 'Garamond, "Times New Roman", serif',
                'courier_new': '"Courier New", Courier, monospace',
                'brush_script_mt': '"Brush Script MT", cursive'
            };

            return fontFamilyCSSMapping[value] || 'Arial, sans-serif';
        }
    }
}
</script>

<style scoped lang="scss">
#mail-preview {
    background-color: #ECEFF0;
    font-size: 1rem;
    color: #6A7272;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.email-bg {
    padding: 2rem;
    overflow-y: scroll;
    flex: 1;
    flex-grow: 2;
}

.email-body {
    max-width: 37.5rem;
    margin: 0 auto;
    padding: 0;
    background-color: #fff;

    .email-body-header {
        padding: 3.125rem 2.1875rem 0 2.1875rem;
        text-align: right;

        img {
            max-width: 131px;
            margin-bottom: 1.11rem;
        }
    }

    .email-body-content {
        padding: 1rem 2.1875rem;

        table {
            th {
                border-bottom: 2px solid var(--border-color, #F9F9F9);
            }

            td {
                border-bottom: 1px solid var(--border-color, #F9F9F9);
            }

            tr:last-child td {
                border-bottom: none;
            }
        }

        .header {
            font-size: 22px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 0.3125rem;
        }

        .body {
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }

        .download-button {
            color: #fff;
            padding: 8px 19px;
            border-radius: 22px;
            background: #3BC173;
            font-size: 16px;
            display: table;
            cursor: pointer;
        }

        .nps-icon {
            cursor: pointer;
            margin-top: 10px;
            margin-right: 8px;
            width: 38px;
            height: 38px;
        }
    }

    .footer-logo {
        text-align: center;
        padding-bottom: 30px;
        padding-top: 30px;
        border-top: 0.063rem solid var(--divider-color, #F9F9F9);

        img {
            width: 91px;
            height: 36px;
        }
    }

    .email-support-footer {
        text-align: left;
        padding: 1.325rem 2.297rem;

        u {
            color: #000;
        }
    }
}

.email-footer {
    text-align: center;
    color: #a7a7a7;
    font-size: 0.75rem;
    margin-top: 2.22rem;

    &.light-text {
        color: #ffffff;
    }

    &.dark-text {
        color: #000000;
    }
}

.meta {
    font-size: 0.875rem;
    padding: 0.8rem 1rem;
    background-color: #fff;

    .attachments {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;

        strong {
            margin-right: 0.2rem;
        }

        .attachment {
            background-color: #F5F5F5;
            color: #4A4A4A;
            padding: 0 0.3rem;
            font-size: 0.75rem;
            border-radius: 0.188rem;
            margin: 0.1rem 0.2rem 0.1rem 0;
            flex: 0 0 auto;
            white-space: nowrap;

            .icon {
                position: relative;
                top: 0.15rem;
                font-size: 0.8rem;
            }
        }
    }
}
</style>
